import React, { forwardRef, useEffect, useState } from 'react';

export type TextInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
    className?: string;
    variant?: 'text' | 'number';
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    validate?: (value: string) => boolean;
    name: string;
    autoResize?: boolean;
    value: string;
};

const PATTERN = '^[0-9]*[.|,]?[0-9]*$';

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
    (
        {
            className = '',
            variant = 'number',
            onChange = () => {},
            validate,
            name,
            autoResize = false,
            value,
            ...rest
        },
        ref
    ) => {
        const [width, setWidth] = useState(0);

        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            let { value } = event.target;

            if (variant === 'number' && value.includes(',')) {
                value = value.replace(',', '.');
            }

            if (validate && !validate(value)) return;

            if (
                variant === 'text' ||
                value === '' ||
                (value !== '.' &&
                    Number(value) < Number.MAX_SAFE_INTEGER &&
                    value.match(PATTERN))
            ) {
                event.target.value = value;

                onChange(event);
            }
        };

        useEffect(() => {
            if (autoResize) {
                setWidth(value.length);
            }
        }, [autoResize, value]);

        return (
            <input
                ref={ref}
                type={variant}
                style={{ width: autoResize ? `${width}ch` : undefined }}
                inputMode={variant === 'number' ? 'decimal' : 'text'}
                pattern={variant === 'number' ? PATTERN : rest.pattern}
                name={name}
                onChange={handleChange}
                className={`text-input ${className}`}
                value={value}
                {...rest}
            />
        );
    }
);

export default TextInput;
